import React, { useEffect, useState } from 'react';
import { Button } from 'appkit-react';
import { Toast, useDebounce } from '@components';
import { Form, Input, Spin, Tooltip } from 'antd';

import { connect, useDispatch } from 'react-redux';
import action from '@flux/action';
import { deepCopy } from '@utils/common';
import useTheme from '@hooks/useTheme';

function ProjectToast(props) {
  const {
    isShow,
    setIsShow,
    whichSide,
    loading,
    disabled,
    queryDUNSCompanyNum,
    queryCompanyName,
    DUNsNumberList,
    changeDUNSlistData,
    saveData,
    saveCreateProjectData,
    form,
    queryCompanyResult,
  } = props;
  const [value, setValue] = useState('');
  const [pageNum, setPageNum] = useState(1);
  const dispatch = useDispatch();
  const { theme } = useTheme();
  const isLightMode = theme === 'light';

  const DUNsHandler = useDebounce((pageUrl) => {
    queryDUNSCompanyNum(pageUrl);
  }, 1000);

  const pageNumHandler = useDebounce((num) => {
    if (value.length > 2) {
      const val = isNaN(parseInt(num)) ? 1 : parseInt(num);
      if (val < 1 || val > DUNsNumberList?.pagination?.pageCount) {
        return null;
      }
      setPageNum(val);
      const pageUrl = `?keyword=${value}&mode=factiva&pageSize=${
        DUNsNumberList?.pagination?.pageSize
      }&offset=${
        (val - 1) * DUNsNumberList?.pagination?.pageSize + 1
      }&context=${DUNsNumberList?.context}`;

      queryDUNSCompanyNum(pageUrl);
    }
  }, 1000);

  useEffect(
    () => () => {
      changeDUNSlistData({
        companyList: [],
        pagination: {},
      });
      dispatch(action.changeQueryCompanyLoading(false));
    },
    [isShow],
  );

  return (
    <Toast
      isShow={isShow}
      contentStyles={{
        height: 'auto',
        width: 600,
        padding: 0,
        backgroundColor: isLightMode ? '#fff' : '#1E1E1E',
      }}
      content={
        <div className="DUNS-toast-container">
          <div className="DUNS-num-header-box">
            <div className="DUNS-num-text">Find DUNS Number</div>
            <span
              className="appkiticon icon-close-fill"
              onClick={() => setIsShow(!isShow)}
            />
          </div>
          <div className="search-box">
            <Input
              size="large"
              placeholder="Search"
              prefix={<span className="appkiticon icon-search-outline" />}
              onChange={(e) => {
                // DUNsHandler(e.target.value);
                const val = e.target.value;
                const url = `?keyword=${val}&mode=factiva&pageSize=${20}`;
                if (val.length > 2) {
                  DUNsHandler(url);
                }
                setPageNum(1);
                setValue(val);
                form.setFieldsValue({ pageCount: 1 });
              }}
            />
            {loading ? (
              <Spin style={{ marginLeft: '48%', marginTop: 20 }} />
            ) : (
              <div className="DUNS-list-box">
                {Array.isArray(DUNsNumberList.companyList) &&
                DUNsNumberList.companyList.length > 0
                  ? DUNsNumberList.companyList.map((item, idx) => (
                      <div
                        key={idx}
                        className="DUNS-item"
                        onClick={() => {
                          const data = deepCopy(DUNsNumberList);
                          let dunsSearchVal = '';

                          data.companyList.forEach(async (item, index) => {
                            if (idx === index) {
                              item.checked = true;
                              dunsSearchVal = item.duns;
                            } else {
                              item.checked = false;
                            }
                          });
                          queryCompanyName(
                            dunsSearchVal,
                            [`${whichSide}Name`],
                            false,
                            'confirm-craft',
                          );
                          changeDUNSlistData(data);
                        }}
                      >
                        <div className="warning-icon-box">
                          {item.checked &&
                            !disabled &&
                            !queryCompanyResult[`${whichSide}Name`]?.[0]
                              ?.craftId && (
                              <Tooltip
                                placement="bottomLeft"
                                title={
                                  <span style={{ color: '#DBDBDB' }}>
                                    Limited data available for this company.
                                    Data will be updated within next 24 hours.
                                  </span>
                                }
                              >
                                <div>
                                  <span className="appkiticon icon-alert-fill" />
                                </div>
                              </Tooltip>
                            )}
                        </div>
                        <div className="duns-text">
                          {`${item.name} (DUNS: ${item.duns})`}
                        </div>
                        <div
                          className={
                            item.checked ? 'checked-radio-icon' : 'radio-icon'
                          }
                        />
                      </div>
                    ))
                  : DUNsNumberList.context && <div>No result.</div>}
              </div>
            )}
          </div>
          {/* this is a custom pagination , because antd-pagination has a limit.
            we need press enter key when input the page num. that we want to go,
            and the verification function is triggered.  NOT friendly. */}
          {Array.isArray(DUNsNumberList.companyList) &&
            DUNsNumberList.companyList.length > 0 && (
              <div className="pagination-box">
                <span
                  className="appkiticon icon-left-chevron-fill a-font-12"
                  onClick={() => {
                    if (value.length > 2 && pageNum > 1) {
                      const pageUrl = DUNsNumberList?.pagination?.previous;
                      form.setFieldsValue({ pageCount: pageNum - 1 });
                      setPageNum(pageNum - 1);
                      DUNsHandler(pageUrl);
                    }
                  }}
                />
                <div className="pagination-ipt-box">
                  <Form.Item name="pageCount" className="pageCount">
                    <Input
                      defaultValue={pageNum}
                      onChange={(e) => {
                        pageNumHandler(e.target.value);
                      }}
                    />
                  </Form.Item>

                  <div className="total-number">
                    /&nbsp;&nbsp;{DUNsNumberList?.pagination?.pageCount || 0}
                  </div>
                </div>

                <span
                  className="appkiticon icon-right-chevron-fill a-font-12"
                  onClick={() => {
                    if (
                      value.length > 2 &&
                      pageNum + 1 <= DUNsNumberList?.pagination?.pageCount
                    ) {
                      const pageUrl = DUNsNumberList?.pagination?.next;
                      form.setFieldsValue({ pageCount: pageNum + 1 });
                      setPageNum(pageNum + 1);
                      DUNsHandler(pageUrl);
                    }
                  }}
                />
              </div>
            )}

          <div className="btn-box">
            <Button
              className="cancel btn"
              kind="second"
              // isLoading={loading}
              onClick={() => {
                setIsShow(!isShow);
              }}
            >
              cancel
            </Button>
            <Button
              className="save btn"
              // type="primary"
              disabled={disabled}
              // isLoading={loading}
              onClick={(e) => {
                if (
                  Array.isArray(DUNsNumberList.companyList) &&
                  DUNsNumberList.companyList.length > 0
                ) {
                  DUNsNumberList.companyList.forEach((item) => {
                    if (item.checked) {
                      if (queryCompanyResult[`${whichSide}Name`]?.[0].craftId) {
                        // if we can get result from craft by duns, enter here.
                        form.setFieldsValue({
                          [`${whichSide}Name`]: `${item.name} (DUNS : ${
                            queryCompanyResult[`${whichSide}Name`][0].duns
                          })`,
                        });

                        saveCreateProjectData({
                          ...saveData,
                          [`${whichSide}Name`]: item.name,
                          [`${whichSide}CraftId`]:
                            queryCompanyResult[`${whichSide}Name`][0].craftId,
                          [`${whichSide}Duns`]:
                            queryCompanyResult[`${whichSide}Name`][0].duns,
                          [`${whichSide}CompanyInfo`]: {
                            isFromDuns: false,
                          },
                        });
                      } else {
                        // if we can NOT get result from craft by duns, enter here.
                        saveCreateProjectData({
                          ...saveData,
                          [`${whichSide}Name`]: null,
                          [`${whichSide}CraftId`]: null,
                          [`${whichSide}CompanyInfo`]: {
                            name: item.name,
                            isFromDuns: true,
                            companyWebsite:
                              queryCompanyResult[`${whichSide}Name`]?.[0]
                                ?.website || null,
                            duns: item.duns,
                          },
                          // buyerNotFound: whichSide === 'buyer',
                          // targetNotFound: whichSide === 'target',
                        });
                        form.setFieldsValue({
                          [`${whichSide}Name`]: '',
                        });
                      }
                      setIsShow(!isShow);
                    }
                  });
                }
              }}
            >
              Add
            </Button>
          </div>
        </div>
      }
    />
  );
}

const mapStateToProps = ({ projects }) => ({
  loading: projects.queryCompanyLoading,
  disabled: projects.createProjectDisabled,
  DUNsNumberList: projects.DUNsNumberList,
  saveData: projects.saveData,
  queryCompanyResult: projects.queryCompanyResult || {},
});

const mapDispatchToProps = (dispatch) => ({
  queryDUNSCompanyNum(word, pageSize) {
    dispatch(action.queryDUNSCompanyNum(word, pageSize));
  },
  changeDUNSlistData(dunsData) {
    dispatch(action.changeDUNSlistData(dunsData));
  },
  saveCreateProjectData(data) {
    dispatch(action.saveData(data));
  },
  queryCompanyName(word, type, isLoading, mode) {
    dispatch(action.queryCompanyName(word, type, isLoading, mode));
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(ProjectToast);
